import { render, staticRenderFns } from "./ManageOccurrenceTypeListView.vue?vue&type=template&id=2f7f318a"
import script from "./ManageOccurrenceTypeListView.vue?vue&type=script&lang=ts"
export * from "./ManageOccurrenceTypeListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports